/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const postContent = (
	<SVG xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 6h12V4.5H4V6Zm16 4.5H4V9h16v1.5ZM4 15h16v-1.5H4V15Zm0 4.5h16V18H4v1.5Z" />
	</SVG>
);

export default postContent;
